import { differenceInCalendarDays } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { useLayoutStore } from "@/stores/layout.ts";
import { useUserStore } from "@/stores/user.ts";

const DISRUPTION_PATHS_REGEX =
  /^\/(?:archiv\/(?:detail|bookmark)|(?:desk|cvd|messenger|ai-research|archiv|intelligence))(?:\/|$)/;
const MORNING_BRIEFING_PATH_REGEX = /^\/(cvd\/top-themen)(\/|$)/;
const TRIAL_BANNER_DAYS_BEFORE_END = 14;

export default function useGlobalBanners() {
  const route = useRoute();
  const layoutStore = useLayoutStore();
  const userStore = useUserStore();
  const { locale } = useI18n();

  const showDisruptionBanner = computed(() => {
    const { state, sections } = layoutStore.disruptionBanner;
    if (state === "inactive") {
      return false;
    }
    if (sections.includes("all")) {
      return DISRUPTION_PATHS_REGEX.test(route.path);
    }
    return sections.some((section) => route.path.includes(section));
  });

  const disruptionBannerMessage = computed(() => {
    if (locale.value === "es") {
      return layoutStore.disruptionBanner.messageEs;
    }
    if (locale.value === "en") {
      return layoutStore.disruptionBanner.messageEn;
    }
    return layoutStore.disruptionBanner.messageDe;
  });

  const showMorningBriefingBanner = computed(
    () =>
      layoutStore.morningBriefingBanner.active &&
      MORNING_BRIEFING_PATH_REGEX.test(route.path),
  );

  const showRemainingTrialBanner = computed(
    () =>
      !userStore.deactivated &&
      !!userStore.validToDate &&
      differenceInCalendarDays(userStore.validToDate, new Date()) <=
        TRIAL_BANNER_DAYS_BEFORE_END,
  );

  const showBanners = computed(
    () =>
      showDisruptionBanner.value ||
      showMorningBriefingBanner.value ||
      showRemainingTrialBanner.value,
  );

  return {
    showBanners,
    showDisruptionBanner,
    disruptionBannerMessage,
    showMorningBriefingBanner,
    showRemainingTrialBanner,
  };
}
